if(document.querySelector(".product_media-gallery")){
    document.addEventListener('DOMContentLoaded', () => {
        // Select all slides that contain videos
        const slides = document.querySelectorAll('.swiper-slide');

        slides.forEach(slide => {
            // Remove controls and icons for video
            const videoElement = slide.querySelector('video');
            if (videoElement) {
                videoElement.removeAttribute('controls'); // Remove controls
                videoElement.muted = true;  // Mute video for autoplay
                videoElement.loop = true;
                videoElement.setAttribute('playsinline', ''); // Remove fullscreen button on mobile
            }

            // Observe the class changes on each slide
            const observer = new MutationObserver(() => {
                if (videoElement) {
                    if (slide.classList.contains('swiper-slide-active')) {
                        videoElement.play(); // Play video when the class is added
                    } else {
                        videoElement.pause(); // Pause video when the class is removed
                    }
                }
            });

            // Start observing class changes
            observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
        });
    });
}